module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/cover-1-4bce531f59811b16b301c90c7c28d027.webp";